import LoginForm from '../LoginForm';
import Illustration from '../Illustration';

export default function LogIn() {
  return (
    <>
      <h1>Login to your account</h1>
      <div class="column">
        <Illustration />
   <LoginForm/>
      </div>
    </>
  );
}
